import { ReportStatusEnum } from "domain/reports/enums"

type TDownloadBtnState = {
  label: string
  isDisabled: boolean
}

export const downloadBtnState = (
  status: ReportStatusEnum
): TDownloadBtnState => {
  let label
  let isDisabled = true

  switch (status) {
    case ReportStatusEnum.DOWNLOADING:
      label = "Downloading..."
      break
    case ReportStatusEnum.CREATION:
      label = "File Creation..."
      break
    default:
      label = "Download Report"
      isDisabled = false
      break
  }

  return { label, isDisabled }
}
